/**
 * PATH: apps/assets/src/pages/AssetsPage.tsx
 * PURPOSE: Asset list and management
 */
import { EmptyRegister } from './emptyRegister'

export default function AssetsPage() {
  return (
    <EmptyRegister
      title="Assets"
      detail="No assets are connected."
    />
  )
}
